module.exports = __webpack_public_path__ + "static/img/cabinet5_1.bc626df6.gif";